import { AxiosError } from 'axios';
import { useCustomMutation } from '../utils/useCustomMutation';
import { PUT_SUBJECT_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface PutSubjectResponse {}

export interface ScDetailFromData {
  specialConsiderationType: string;
  reason: string;
  explanation: string;
}

export interface PutSubjectRequest extends ScDetailFromData {
  subjectUuid: string;
  paperUuid: string;
  requestUuid: string;
  uuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePutSubject = ({ onSuccess, onError }: Input = {}) => {
  const postExamLevels = async (reqBody: PutSubjectRequest) => {
    const res = await axiosClient.put<PutSubjectResponse>(
      PUT_SUBJECT_URL(reqBody.requestUuid, reqBody.uuid),
      {
        subjectUuid: reqBody.subjectUuid,
        paperUuid: reqBody.paperUuid,
        specialConsiderationType: reqBody.specialConsiderationType,
        reason: reqBody.reason,
        explanation: reqBody.explanation,
      }
    );
    return res.data;
  };

  return useCustomMutation(postExamLevels, {
    onSuccess,
    onError,
  });
};
